import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import {
  SettingsColumnStyled,
  SettingsSectionStyled,
} from '../../DirectBookingEngine.styles';

const TrackingSettingsSection = () => {
  const { t } = useTranslation();

  const fieldProps = {
    colSmInput: 7,
    colSmLabel: 5,
  };

  return (
    <SettingsSectionStyled
      data-testid="tracking-settings-section"
      defaultExpanded
      label={t('pageDirectBookingEngine.trackingSettings.sectionTitle')}
      variant="card"
    >
      <Row>
        <SettingsColumnStyled>
          <TextField
            {...fieldProps}
            label={t(
              'pageDirectBookingEngine.trackingSettings.googleAnalyticsId',
            )}
            name="tracking.googleAnalyticsId"
            placeholder={t(
              'pageDirectBookingEngine.trackingSettings.googleAnalyticsIdPlaceholder',
            )}
            rightTooltip={t(
              'pageDirectBookingEngine.trackingSettings.googleAnalyticsIdTooltip',
            )}
          />
          <TextField
            {...fieldProps}
            label={t(
              'pageDirectBookingEngine.trackingSettings.googleTagManagerId',
            )}
            name="tracking.googleTagManagerId"
            placeholder={t(
              'pageDirectBookingEngine.trackingSettings.googleTagManagerIdPlaceholder',
            )}
            rightTooltip={t(
              'pageDirectBookingEngine.trackingSettings.googleTagManagerIdTooltip',
            )}
          />
          <TextField
            {...fieldProps}
            label={t('pageDirectBookingEngine.trackingSettings.metaPixelId')}
            name="tracking.metaPixelId"
            placeholder={t(
              'pageDirectBookingEngine.trackingSettings.metaPixelIdPlaceholder',
            )}
            rightTooltip={t(
              'pageDirectBookingEngine.trackingSettings.metaPixelIdTooltip',
            )}
          />
        </SettingsColumnStyled>
      </Row>
    </SettingsSectionStyled>
  );
};

export default TrackingSettingsSection;
